import React from 'react';

import { useTranslation } from 'react-i18next';

import slideImg1 from '@assets/images/welcome/sk2_intro.webp';

import useIsInIframe from '@hooks/use-is-in-iframe';

import { Button } from '@components/button';

import * as Styled from './sk2-welcome.styles';

type OwnProps = {
	slide: number;
	onClickNext: () => void;
	onClickPrevious: () => void;
};

const Sk2Welcome: React.FC<OwnProps> = ({ slide, onClickNext, onClickPrevious }) => {
	const isInIframe = useIsInIframe();
	const { t } = useTranslation('sk2Welcome');

	return (
		<Styled.Wrapper $isIframe={isInIframe}>
			<Styled.Content>
				<Styled.ContentLeft>
					<Styled.Title>{t(slide === 1 ? 'title1' : 'title2')}</Styled.Title>

					<Styled.Text
						dangerouslySetInnerHTML={{
							__html: t(slide === 1 ? 'text1' : 'text2')
						}}
					/>

					<Styled.ButtonRow>
						{slide > 1 && (
							<Button minWidth={75} color='dark' onClick={onClickPrevious}>
								{t('main:back')}
							</Button>
						)}
						<Button minWidth={75} color='primary' onClick={onClickNext}>
							{t('button_text')}
						</Button>
					</Styled.ButtonRow>
				</Styled.ContentLeft>
				<Styled.IntroPic src={slideImg1} alt='intro' />
			</Styled.Content>
		</Styled.Wrapper>
	);
};

export default Sk2Welcome;
